import { defineComponent as a, createBlock as r, openBlock as l, unref as p, mergeProps as c, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const d = /* @__PURE__ */ a({
  name: "IconArrowDownLeftInCircle",
  __name: "IconArrowDownLeftInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (s, t) => (l(), r(p(i), c(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...t[0] || (t[0] = [
        e("path", { d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m0-1.5c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25" }, null, -1),
        e("path", { d: "M8.47 14.47a.75.75 0 0 0 1.06 1.06l6-6a.75.75 0 0 0-1.06-1.06l-6 6" }, null, -1),
        e("path", { d: "M9.386 10.293a.75.75 0 0 0-1.5 0v4.571a1.25 1.25 0 0 0 1.25 1.25h4.571a.75.75 0 1 0 0-1.5H9.386v-4.321" }, null, -1),
        e("path", { d: "M7.886 10.293a.75.75 0 0 1 1.5 0v3.26L14.47 8.47a.75.75 0 1 1 1.06 1.06l-5.084 5.084h3.261a.75.75 0 1 1 0 1.5H9.136a1.25 1.25 0 0 1-1.25-1.25v-4.571" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
